<daypilot-scheduler [config]="configUpper" [events]="eventsUpper" #schedulerUpper></daypilot-scheduler>
<audio #audioOption>
  <source src='../../../assets/door_chime.mp3' type="audio/mp3">
</audio>
